

















































































































import { Vue, Prop, Component, Watch } from "vue-property-decorator";
import SideBar from "@/zh-website/src/components/website/SideBar.vue";
@Component({
  components: { SideBar }
})
export default class AboutPurchase extends Vue {}
